import { create } from "zustand";
import type { OptimizelyStoreProps } from "./OptimizelyStore.d";

export const useOptimizelyStore = create<OptimizelyStoreProps>((set) => ({
  isLoaded: false,
  isLoading: false,
  hasError: false,
  setOptimizelyLoading: () => set(() => ({ isLoaded: false, isLoading: true })),
  setOptimizelyLoaded: () => set(() => ({ isLoaded: true, isLoading: false, hasError: false })),
  setOptimizelyError: () => set(() => ({ hasError: true, isLoading: false })),
}));
